import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Loader2 } from 'lucide-react';

const DeleteEmployeeModal = ({
  showDeleteDialog,
  setShowDeleteDialog,
  selectedEmployee,
  handleDeleteEmployee,
  isDeleting
}) => {
  return (
    <Dialog open={showDeleteDialog} onOpenChange={setShowDeleteDialog}>
      <DialogContent data-testid="delete-employee-dialog">
        <DialogHeader>
          <DialogTitle>Çalışanı Sil</DialogTitle>
          <DialogDescription>
            {selectedEmployee?.name} isimli çalışanı silmek istediğinize emin misiniz?
            Bu işlem geri alınamaz.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={() => setShowDeleteDialog(false)} disabled={isDeleting}>
            İptal
          </Button>
          <Button variant="destructive" onClick={handleDeleteEmployee} disabled={isDeleting}>
            {isDeleting ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : null}
            Sil
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteEmployeeModal;